import type { CompanyRef } from '@/domain/types/User'

type WithCompanies = {
  inactiveCompanyIds?: unknown
  companiesRef?: CompanyRef[] | null
  companyIds?: string[] | null
  companyId?: string | null
} | null | undefined

/** Ids de compañías donde el usuario está desactivado; tolera valores mal formados. */
export function inactiveCompanyIdsOf(user: WithCompanies): string[] {
  const raw = user?.inactiveCompanyIds
  if (!Array.isArray(raw)) return []
  return raw.filter((id): id is string => typeof id === 'string' && id !== '')
}

/** ¿Está desactivado en esa compañía? */
export function isInactiveInCompany(user: WithCompanies, companyId: string | null | undefined): boolean {
  return !!companyId && inactiveCompanyIdsOf(user).includes(companyId)
}

/** Ids de todas sus compañías: companyIds ∪ companiesRef[].id ∪ companyId (sin vacíos ni duplicados). */
export function companyIdsOfUser(user: WithCompanies): string[] {
  const ids = new Set<string>(user?.companyIds || [])
  for (const ref of user?.companiesRef || []) {
    if (ref?.id) ids.add(ref.id)
  }
  if (user?.companyId) ids.add(user.companyId)
  return [...ids].filter(Boolean)
}

/** companiesRef sin las compañías donde está desactivado (para el selector). */
export function activeCompaniesRefOf(user: WithCompanies): CompanyRef[] {
  const inactive = inactiveCompanyIdsOf(user)
  return (user?.companiesRef || []).filter((c) => !inactive.includes(c.id))
}

/** Se lanza cuando el usuario no tiene ninguna compañía activa y no debe iniciar sesión. */
export class UserInactiveError extends Error {
  readonly code = 'auth/user-inactive'

  constructor() {
    super('auth/user-inactive')
    this.name = 'UserInactiveError'
  }
}
